import React, { useEffect, useState } from "react";
import steps from "../../assets/steps.png";
import time from "../../assets/time.png";
import user from "../../assets/user.png";
import mail from "../../assets/mail.png";
import camira from "../../assets/camira.png";

import { parsePhoneNumberFromString } from "libphonenumber-js";
import { Button, Form, Input, message, Modal, Select, Upload } from "antd";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { useTranslation } from "react-i18next";
import { joinSamoolahFunction } from "../../redux/ecommerce/joinSamoolahSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchConstructionServices } from "../../redux/constructionServicesSlice";
import { fetchCategories } from "../../redux/categoriesSlice";
import { fetchFacilitesServices } from "../../redux/facilitesServicesSlice";
import { fetchFacilitescategory } from "../../redux/facilitesCategoriesSlice";
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
const { TextArea } = Input;

const JoinSamoolah = () => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const [serverLink, setServerLink] = useState("");
  const [serverEmail, setServerEmail] = useState("");
  const [serverPass, setServerPass] = useState("");

  const [modalContent, setModalContent] = useState("");

  const [countryCode, setcountryCode] = useState("");

  const [loadingForm, setLoadingForm] = useState(false);
  const [errorForm, setErrorForm] = useState("");

  const [phone, setPhone] = useState("");
  const [selected, setSelected] = useState("agent");
  const [selectedTwo, setSelectedTwo] = useState("both");
  const [selectedConstructionService, setSelectedConstructionService] =
    useState([]);

  const [selectedPrevService, setSelectedPrevService] = useState([]);

  const [selectedFacService, setSelectedFacService] = useState([]);

  // const [selectedFacCategory, setSelectedFacCategory] = useState("");

  const [formData, setFormData] = useState({
    firstname: "",
    mail: "",
    email: "",
    phone: "",
    country_code: "",
    user_role: "",
    send_by: selectedTwo,
    desc_ar: "",
    desc_en: "",
    documents_images: [],
    services: [],
    con_services: [],
    image: null,
    store_name_en: "",
    store_name_ar: "",
    // facilites_category: ""
  });
  const [servicesOptions, setServicesOptions] = useState([]);

  const constructionServices = useSelector(
    (state) => state.constructionServices.constructionServices
  );
  const constructionServicesStatus = useSelector(
    (state) => state.constructionServices.status
  );

  const {
    categories,
    status: categoryStatus,
    error,
  } = useSelector((state) => state.categories);

  const { facilitesServices, statusfacilitesServices, errorfacilitesServices } =
    useSelector((state) => state.facilitesServices);

  const { facilitescategory, statusfacilitescategory, errorfacilitescategory } =
    useSelector((state) => state.facilitescategory);

  useEffect(() => {
    if (categoryStatus === "idle") {
      dispatch(fetchCategories());
    }
  }, [categoryStatus, dispatch]);

  useEffect(() => {
    if (constructionServicesStatus === "idle") {
      dispatch(fetchConstructionServices());
    }
  }, [constructionServicesStatus, dispatch]);

  useEffect(() => {
    if (statusfacilitesServices === "idle") {
      dispatch(fetchFacilitesServices());
    }
  }, [statusfacilitesServices, dispatch]);

  useEffect(() => {
    if (statusfacilitescategory === "idle") {
      dispatch(fetchFacilitescategory());
    }
  }, [statusfacilitescategory, dispatch]);

  console.log(facilitesServices);
  console.log(facilitescategory);

  useEffect(() => {
    if (selected === "service_providor") {
      setServicesOptions(
        constructionServices.map((pro) => ({
          label: language === "en" ? pro.name_en : pro.name,
          value: pro.id,
        }))
      );
    } else if (selected === "agent") {
      setServicesOptions([
        ...categories.map((cat) => ({
          label: language === "en" ? cat.name_en : cat.name,
          value: cat.id,
        })),
      ]);
    } else if (selected === "store") {
      setServicesOptions([]);
    } else if (selected === "facilites") {
      setServicesOptions(
        facilitesServices?.map((se) => ({
          label: language === "en" ? se.name_en : se.name,
          value: se.id,
        }))
      );
    }
  }, [selected, constructionServices, categories, facilitesServices, language]);

  useEffect(() => {
    if (selectedTwo === "whats") {
      setSelectedTwo("whats");
    } else if (selectedTwo === "mail") {
      setSelectedTwo("mail");
    } else if (selectedTwo === "both") {
      setSelectedTwo("both");
    }
  }, [selectedTwo, language]);

  const validatePhoneNumber = (countryCode, nationalNumber) => {
    if (countryCode === "20") {
      const regex = /^(10|11|12|15)\d{8}$/;
      return regex.test(nationalNumber);
    }

    if (countryCode === "966") {
      const regex = /^5\d{8}$/;
      return regex.test(nationalNumber);
    }

    return true;
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const [fileList, setFileList] = useState([]);

  const handleUploadChange = ({ fileList }) => {
    setFileList(fileList);
    setFormData((prev) => ({
      ...prev,
      documents_images: fileList.map((file) => file.originFileObj),
    }));
  };

  const handleConstructionService = (value) => {
    setSelectedConstructionService(value);
    console.log(value);
    setFormData((prev) => ({ ...prev, services: value }));
  };

  const handleSelectedPrevService = (value) => {
    setSelectedPrevService(value);
    console.log(value);
    setFormData((prev) => ({ ...prev, con_services: value }));
  };

  const handleSelectedFacService = (value) => {
    setSelectedFacService(value);
    setFormData((prev) => ({ ...prev, services: value }));
  };

  // const handleSelectedFacCategory = (value) => {
  //   setSelectedFacCategory(value);
  //   setFormData((prev) => ({ ...prev, facilites_category: value }));
  // };

  const [form] = Form.useForm();

  const handleSubmit = () => {
    setLoadingForm(true);
    setErrorForm("");

    const updatedFormData = {
      ...formData,
      phone,
      country_code: countryCode,
      user_role: selected,
      send_by: selectedTwo,
      image: fileList[0]?.originFileObj || null,
      // services: selected === "facilites"
      // ? selectedFacService
      // : selectedConstructionService,
      services: selected === "facilities"
        ? selectedFacService
        : selectedConstructionService,
      con_services: selectedPrevService.length > 0 ? selectedPrevService : [],
      documents_images: fileList.map((file) => file.originFileObj),
    };

    if (selectedConstructionService === "store") {
      updatedFormData.email = formData.email;
    } else {
      updatedFormData.mail = formData.email;
    }

    dispatch(joinSamoolahFunction({
    data: updatedFormData,
    selected,
  }))
      .unwrap()
      .then((response) => {
        const status = response?.status;
        const messageText =
          response?.message ||
          response?.data?.user ||
          "تم التسجيل بنجاح!";

        if (status === false) {
          setErrorForm(messageText || "حدث خطأ ما، يرجى المحاولة لاحقاً");
          message.error(messageText || "حدث خطأ ما، يرجى المحاولة لاحقاً");

          form.resetFields();

          setFormData({
            firstname: "",
            mail: "",
            email: "",
            phone: "",
            country_code: "",
            user_role: "",
            send_by: "both",
            desc_ar: "",
            desc_en: "",
            documents_images: [],
            services: [],
            con_services: [],
            image: null,
            store_name_en: "",
            store_name_ar: "",
          });

          setPhone("");
          setSelected("service_providor");
          setSelectedTwo("both");
          setSelectedConstructionService([]);
          setSelectedPrevService([]);
          setSelectedFacService([]);
          setFileList([]);
        }
        else if (status === true || status === 200) {
          const isMobile = window.innerWidth <= 768;

          const userMessage = response?.data?.user;
          const messageText =
            typeof userMessage === "string" ? userMessage : "تم التسجيل بنجاح!";

          setServerLink(response?.data?.link);
          setServerEmail(response?.data?.mail);
          setServerPass(response?.data?.password);

          if (isMobile) {
            setModalContent(messageText);
            setShowModal(true);
          } else {
            message.success(messageText);
          }
          navigate("/");

          form.resetFields();

          setFormData({
            firstname: "",
            mail: "",
            email: "",
            phone: "",
            country_code: "",
            user_role: "",
            send_by: "both",
            desc_ar: "",
            desc_en: "",
            documents_images: [],
            services: [],
            con_services: [],
            image: null,
            store_name_en: "",
            store_name_ar: "",
            // facilites_category: ""
          });

          setPhone("");
          setSelected("agent");
          setSelectedTwo("both");
          setSelectedConstructionService([]);
          setSelectedPrevService([]);
          setSelectedFacService([]);
          setFileList([]);
        }
        else {
          setErrorForm("حدث خطأ غير متوقع، حاول مرة أخرى.");
          message.error("حدث خطأ غير متوقع، حاول مرة أخرى.");
        }
      })
      .catch((error) => {
        setErrorForm(error.message || "حدث خطأ أثناء التسجيل!");
        message.error(`Error booking service: ${error.message || error}`);

        form.resetFields();

        setFormData({
          firstname: "",
          mail: "",
          email: "",
          phone: "",
          country_code: "",
          user_role: "",
          send_by: "both",
          desc_ar: "",
          desc_en: "",
          documents_images: [],
          services: [],
          con_services: [],
          image: null,
          store_name_en: "",
          store_name_ar: "",
        });

        setPhone("");
        setSelected("agent");
        setSelectedTwo("both");
        setSelectedConstructionService([]);
        setSelectedPrevService([]);
        setSelectedFacService([]);
        setFileList([]);
      })
      .finally(() => setLoadingForm(false));
  };

  return (
    <div className="relative" dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="bg-[#FCFBFA] w-full py-14 JoinSamoolah">
        {/* <h3 className="text-[#14294F] text-2xl font-bold text-center">
          {t("Join Samoolah NOW")}
        </h3> */}
        <div className="flex justify-center">
          <h3 className="
  text-[#14294F]
  text-3xl
  font-extrabold
  text-center
  px-6
  py-3
  border-4
  border-[#EAA182]
  rounded-xl
  shadow-sm
  text-center
  mx-auto
  
">
            {t("Join Samoolah NOW")}
          </h3>
        </div>
        <p className="text-[#737E91] text-lg mt-3 w-1/2 max-lg:w-full max-lg:px-4 text-center mx-auto">
          {t(
            "Experience the convenience of booking home services and shopping for products anytime, anywhere."
          )}
        </p>
        <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 px-20 max-lg:px-5 mt-8 lg:items-center">
          <div>
            <div className="flex items-center">
              <img
                src={steps}
                className={`w-[80px] ${language == "en" ? "mr-5" : "ml-5"}`}
              />
              <div>
                <h5 className="text-[#283D63] text-2xl mt-3 font-semibold">
                  {t("Step 1")}
                </h5>
                <p className="text-[#737E91] text-lg mt-3">
                  {t(
                    "Enter your personal details along with your preferred role"
                  )}
                </p>

                <div className="my-16">
                  <h5 className="text-[#283D63] text-2xl mt-3 font-semibold">
                    {t("Step 2")}
                  </h5>
                  <p className="text-[#737E91] text-lg mt-3">
                    {t(
                      "Select your preferred method for receiving your credentials"
                    )}
                  </p>
                </div>

                <h5 className="text-[#283D63] text-2xl mt-3 font-semibold">
                  {t("Step 3")}
                </h5>
                <p className="text-[#737E91] text-lg mt-3">
                  {t(
                    "Submit your responses and wait to receive your credentials and login information"
                  )}
                </p>
              </div>
            </div>

            <div className="lg:mr-20">
              <img src={time} className="mx-auto w-[80px] mt-14" />
              <p className="text-[#737E91] text-lg mt-3 w-1/2 max-lg:w-full text-center mx-auto">
                {t(
                  "Within 24 hrs you will receive an update on your submission"
                )}
              </p>
            </div>
          </div>
          <Form form={form} onFinish={handleSubmit}>
            <div className="bg-white border-2 border-[#EAA182] rounded-3xl p-8 max-lg:p-5">
              <div className="mt-5">
                <p className="text-[#283D63] text-center font-semibold">
                  {t("Company Name")} <span className="text-[#CC0F0F]">*</span>
                </p>
                <Form.Item
                  name="firstname"
                  rules={[
                    {
                      required: true,
                      message: t("Please input your company name!"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("Example: Company...")}
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                    value={formData.firstname}
                    suffix={<img src={user} className="w-[15px]" />}
                    onChange={(e) => {
                      setFormData({ ...formData, firstname: e.target.value });
                    }}
                    required
                  />
                </Form.Item>
              </div>

              <div className="mt-5" dir="ltr">
                <p className="text-[#283D63] text-center font-semibold">
                  {t("Phone Number")} <span className="text-[#CC0F0F]">*</span>
                </p>

                {/* <Form.Item
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: t("Please input your phone number!"),
                    },
                  ]}
                >
                  <PhoneInput
                    defaultCountry="sa"
                    value={phone}
                    // onChange={(phone) => setPhone(phone)}
                    onChange={(value) => {
                      setPhone(value);

                      const phoneNumber = parsePhoneNumberFromString(value);

                      if (phoneNumber) {
                        const dialCode = phoneNumber.countryCallingCode;
                        const nationalNumber = phoneNumber.nationalNumber;
                        setcountryCode(dialCode);

                        console.log("✅ كود الدولة:", dialCode); // مثلاً: 966
                        // console.log("📞 الرقم المحلي:", nationalNumber); // مثلاً: 501234567
                      } else {
                        console.warn("📛 الرقم غير صالح");
                      }
                    }}
                    className={`bg-white w-full p-2 rounded placeholder:text-black placeholder:text-xl placeholder:font-normal placeholder:font-Arimo`}
                    required
                  />
                </Form.Item> */}

                {/* <Form.Item
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: t("Please input your phone number!"),
                    },
                    {
                      validator: (_, value) => {
                        const phoneNumber = parsePhoneNumberFromString(value || "");
                        if (phoneNumber) {
                          const dialCode = phoneNumber.countryCallingCode;
                          const nationalNumber = phoneNumber.nationalNumber;

                          if (!validatePhoneNumber(dialCode, nationalNumber)) {
                            return Promise.reject(
                              dialCode === "20"
                                ? "رقم الهاتف المصري غير صحيح (10 أرقام بدون صفر)."
                                : dialCode === "966"
                                  ? "رقم الهاتف السعودي غير صحيح (9 أرقام ويبدأ بـ 5)."
                                  : "رقم الهاتف غير صالح."
                            );
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <PhoneInput
                    defaultCountry="sa"
                    value={phone}
                    onChange={(value) => {
                      setPhone(value);

                      const phoneNumber = parsePhoneNumberFromString(value);

                      if (phoneNumber) {
                        const dialCode = phoneNumber.countryCallingCode;
                        const nationalNumber = phoneNumber.nationalNumber;
                        setcountryCode(dialCode);

                        console.log("✅ كود الدولة:", dialCode);
                        console.log("📞 الرقم المحلي:", nationalNumber);

                        // تحقق من الرقم
                        const isValid = validatePhoneNumber(dialCode, nationalNumber);
                        if (!isValid) {
                          message.error(
                            dialCode === "20"
                              ? "رقم الهاتف المصري يجب أن يكون 10 أرقام ويبدأ بـ 10 أو 11 أو 12 أو 15 فقط (بدون صفر في البداية)."
                              : dialCode === "966"
                                ? "رقم الهاتف السعودي يجب أن يكون 9 أرقام ويبدأ بـ 5 (بدون صفر في البداية)."
                                : "رقم الهاتف غير صالح."
                          );
                        }
                      } else {
                        console.warn("📛 الرقم غير صالح");
                      }
                    }}
                    className="bg-white w-full p-2 rounded placeholder:text-black placeholder:text-xl placeholder:font-normal placeholder:font-Arimo"
                    required
                  />

                </Form.Item> */}

                <Form.Item
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: t("Please input your phone number!"),
                    },
                    {
                      validator: (_, value) => {
                        const phoneNumber = parsePhoneNumberFromString(value || "");
                        if (phoneNumber) {
                          const dialCode = phoneNumber.countryCallingCode;
                          const nationalNumber = phoneNumber.nationalNumber;

                          if (!validatePhoneNumber(dialCode, nationalNumber)) {
                            return Promise.reject(
                              dialCode === "20"
                                ? "رقم الهاتف المصري غير صحيح (10 أرقام بدون صفر)."
                                : dialCode === "966"
                                  ? "رقم الهاتف السعودي غير صحيح (9 أرقام ويبدأ بـ 5)."
                                  : "رقم الهاتف غير صالح."
                            );
                          }
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <PhoneInput
                    defaultCountry="sa"
                    value={phone}
                    onChange={(value) => {
                      setPhone(value);
                      const phoneNumber = parsePhoneNumberFromString(value);
                      if (phoneNumber) {
                        setcountryCode(phoneNumber.countryCallingCode);
                      }
                    }}
                    className="bg-white w-full p-2 rounded placeholder:text-black placeholder:text-xl placeholder:font-normal placeholder:font-Arimo"
                    required
                  />
                </Form.Item>


              </div>

              <div className="mt-5">
                <p className="text-[#283D63] text-center font-semibold">
                  {t("Email")} <span className="text-[#CC0F0F]">*</span>
                </p>
                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: t("Please input your email!"),
                    },
                  ]}
                >
                  <Input
                    placeholder={t("Eg. Solimannhene16@gmail.com")}
                    className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                    value={formData.email}
                    suffix={<img src={mail} className="w-[20px]" />}
                    onChange={(e) => {
                      setFormData({ ...formData, email: e.target.value });
                    }}
                    required
                  />
                </Form.Item>
              </div>

              <div className="mt-5">
                <p className="text-[#283D63] text-center font-semibold">
                  {t("How would you like to join us?")}{" "}
                  <span className="text-[#CC0F0F]">*</span>
                </p>
                <div className="toggle-select lg:flex items-center gap-4 mt-2">
                  <button
                    className={`rounded-3xl py-3 px-3 max-lg:w-full hidden ${selected === "service_providor"
                      ? "bg-[#F9FBFC] text-[#4F71A8] border-2 border-[#4F71A8] font-semibold"
                      : "bg-[#FAF9F8] text-[#999999]"
                      }`}
                    onClick={() => setSelected("service_providor")}
                  >
                    {t("Previews")}
                  </button>
                  <button
                    className={` rounded-3xl py-3 px-3 max-lg:mt-3 max-lg:w-full ${selected === "agent"
                      ? "bg-[#F9FBFC] text-[#4F71A8] border-2 border-[#4F71A8] font-semibold"
                      : "bg-[#FAF9F8] text-[#999999]"
                      }`}
                    onClick={() => setSelected("agent")}
                  >
                    {t("Service Providers")}
                  </button>
                  <button
                    className={` rounded-3xl py-3 px-3 max-lg:mt-3 max-lg:w-full hidden ${selected === "store"
                      ? "bg-[#F9FBFC] text-[#4F71A8] border-2 border-[#4F71A8] font-semibold"
                      : "bg-[#FAF9F8] text-[#999999]"
                      }`}
                    onClick={() => setSelected("store")}
                  >
                    {t("Stores")}
                  </button>
                  <button
                    className={` rounded-3xl py-3 px-3 max-lg:mt-3 max-lg:w-full ${selected === "facilites"
                      ? "bg-[#F9FBFC] text-[#4F71A8] border-2 border-[#4F71A8] font-semibold"
                      : "bg-[#FAF9F8] text-[#999999]"
                      }`}
                    onClick={() => setSelected("facilites")}
                  >
                    {t("Facilities Management")}
                  </button>
                </div>
              </div>

              {selected === "store" ? (
                <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-10 mt-5 lg:items-center">
                  <div>
                    <p className="text-[#283D63] text-center font-semibold">
                      {t("Store name in English")}{" "}
                      <span className="text-[#CC0F0F]">*</span>
                    </p>
                    <Form.Item
                      name="store_name_en"
                      rules={[
                        {
                          required: true,
                          message: t(
                            "Please input your store name in English!"
                          ),
                        },
                      ]}
                    >
                      <Input
                        placeholder={t("Ecommerce name")}
                        className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                        value={formData.store_name_en}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            store_name_en: e.target.value,
                          });
                        }}
                        required
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <p className="text-[#283D63] text-center font-semibold">
                      {t("Store name in Arabic")}{" "}
                      <span className="text-[#CC0F0F]">*</span>
                    </p>
                    <Form.Item
                      name="store_name_ar"
                      rules={[
                        {
                          required: true,
                          message: t("Please input your store name in Arabic!"),
                        },
                      ]}
                    >
                      <Input
                        placeholder={t("Ecommerce name")}
                        className="h-[50px] mt-2 border-0 bg-[#F9FBFC]"
                        value={formData.store_name_ar}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            store_name_ar: e.target.value,
                          });
                        }}
                        required
                      />
                    </Form.Item>
                  </div>
                </div>
              )
                : selected === "facilites" ? null
                  // (
                  //   <div className="mt-5">
                  //     <p className="text-[#283D63] text-center font-semibold">
                  //       {t("Services")} <span className="text-[#CC0F0F]">*</span>
                  //     </p>
                  //     <Form.Item
                  //       name="selectedFacilitesService"
                  //       rules={[
                  //         {
                  //           required: true,
                  //           message: t(
                  //             "Please input at least one Facility service!"
                  //           ),
                  //         },
                  //       ]}
                  //     >
                  //       <Select
                  //         mode="multiple"
                  //         placeholder={t("Choose services")}
                  //         className="w-full mt-2"
                  //         value={selectedFacService}
                  //         onChange={handleSelectedFacService}
                  //         options={facilitesServices?.map((va) => ({
                  //           label: language === "en" ? va.name_en : va.name,
                  //           value: va.id,
                  //         }))}
                  //         required
                  //       />
                  //     </Form.Item>
                  //   </div>
                  //   ) 
                  : (
                    <div className="mt-5">
                      <p className="text-[#283D63] text-center font-semibold">
                        {t("Services")} <span className="text-[#CC0F0F]">*</span>
                      </p>
                      <Form.Item
                        name="selectedConstructionService"
                        rules={[
                          {
                            required: true,
                            message: t("Please input at least one service!"),
                          },
                        ]}
                      >
                        <Select
                          mode="multiple"
                          placeholder={t("Choose services")}
                          className="w-full mt-2"
                          value={selectedConstructionService}
                          onChange={handleConstructionService}
                          // options={constructionServices?.map((pro) => ({
                          //   label: language === "en" ? pro.name_en : pro.name,
                          //   value: pro.id,
                          // }))}
                          options={servicesOptions}
                          required
                        />
                      </Form.Item>
                    </div>
                  )}

              {/* {selected === "agent" ? (
                <div className="mt-5">
                  <p className="text-[#283D63] text-center font-semibold">
                    {t("Previews Services")}{" "}
                    {/* <span className="text-[#CC0F0F]">*</span> *
                  </p>
                  <Form.Item
                    name="selectedPrevService"
                    rules={[
                      {
                        required: false,
                        message: t(
                          "Please input at least one preview service!"
                        ),
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      placeholder={t("Choose previews services")}
                      className="w-full mt-2"
                      value={selectedPrevService}
                      onChange={handleSelectedPrevService}
                      options={constructionServices?.map((pro) => ({
                        label: language === "en" ? pro.name_en : pro.name,
                        value: pro.id,
                      }))}
                    />
                  </Form.Item>
                </div>
              ) : null} */}

              {/* {selected === "facilites" ? (
                <div className="mt-5">
                  <p className="text-[#283D63] text-center font-semibold">
                    {t("Facilites Categories")}{" "}
                    <span className="text-[#CC0F0F]">*</span>
                  </p>
                  <Form.Item
                    name="selectedPrevService"
                    rules={[
                      {
                        required: true,
                        message: t(
                          "Please input one facility category!"
                        ),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("Choose facility category")}
                      className="w-full mt-2"
                      value={selectedFacCategory}
                      onChange={handleSelectedFacCategory}
                      options={facilitescategory?.map((pro) => ({
                        label: language === "en" ? pro.name_en : pro.name,
                        value: pro.id,
                      }))}
                      required
                    />
                  </Form.Item>
                </div>
              ) : null} */}

              {/* <div className=" mt-5 relative">
                <p className="text-[#283D63] text-center font-semibold">
                  {t("Required documents & request in English")}{" "}
                  <span className="text-[#CC0F0F]">*</span>
                </p>
                <TextArea
                  placeholder={t(
                    "Write your request here and upload all the required documents"
                  )}
                  allowClear
                  value={formData.desc_en}
                  onChange={(e) =>
                    setFormData({ ...formData, desc_en: e.target.value })
                  }
                  name="desc_en"
                  className="w-full mt-2 border-0 h-[80px] rounded-3xl"
                  required
                />
              </div> */}

              {/* <div className=" mt-5 relative">
                <p className="text-[#283D63] text-center font-semibold">
                  {t("Required documents & request in Arabic")}{" "}
                  <span className="text-[#CC0F0F]">*</span>
                </p>
                <TextArea
                  placeholder={t(
                    "Write your request here and upload all the required documents"
                  )}
                  allowClear
                  value={formData.desc_ar}
                  onChange={(e) =>
                    setFormData({ ...formData, desc_ar: e.target.value })
                  }
                  name="desc_ar"
                  className="w-full mt-2 border-0 h-[80px] rounded-3xl"
                  required
                />
                {selected === "store" ? (
                  <Form.Item
                    name="uploadStore"
                    rules={[
                      {
                        required: true,
                        message: t("Please upload at least one image!"),
                      },
                    ]}
                  >
                    <Upload
                      fileList={fileList}
                      onChange={handleUploadChange}
                      beforeUpload={() => false}
                      listType="picture"
                    >
                      <img
                        src={camira}
                        className="w-[40px] absolute -right-4 -top-7 z-10 cursor-pointer"
                      />
                    </Upload>
                  </Form.Item>
                ) : (
                  <Form.Item
                    name="upload"
                    rules={[
                      {
                        required: true,
                        message: t("Please upload at least one image!"),
                      },
                    ]}
                  >
                    <Upload
                      fileList={fileList}
                      onChange={handleUploadChange}
                      beforeUpload={() => false}
                      multiple
                      listType="picture"
                    >
                      <img
                        src={camira}
                        className="w-[40px] absolute -right-4 -top-7 z-10 cursor-pointer"
                      />
                    </Upload>
                  </Form.Item>
                )}
              </div> */}

              <div className="mt-5">
                <p className="text-[#283D63] text-center font-semibold">
                  {t("How would you like to be contacted?")}{" "}
                  <span className="text-[#CC0F0F]">*</span>
                </p>
                <div className="toggle-select flex max-lg:flex-col items-center justify-between mt-2">
                  <button
                    className={` rounded-3xl py-4 px-10 max-lg:w-full ${selectedTwo === "whats"
                      ? "bg-[#F9FBFC] text-[#4F71A8] border-2 border-[#4F71A8] font-semibold"
                      : "bg-[#FAF9F8] text-[#999999]"
                      }`}
                    onClick={() => setSelectedTwo("whats")}
                  >
                    {t("Whatsapp")}
                  </button>
                  <button
                    className={` rounded-3xl py-4 px-10 max-lg:mt-3 max-lg:w-full ${selectedTwo === "mail"
                      ? "bg-[#F9FBFC] text-[#4F71A8] border-2 border-[#4F71A8] font-semibold"
                      : "bg-[#FAF9F8] text-[#999999]"
                      }`}
                    onClick={() => setSelectedTwo("mail")}
                  >
                    {t("Email")}
                  </button>
                  <button
                    className={` rounded-3xl py-4 px-10 max-lg:mt-3 max-lg:w-full ${selectedTwo === "both"
                      ? "bg-[#F9FBFC] text-[#4F71A8] border-2 border-[#4F71A8] font-semibold"
                      : "bg-[#FAF9F8] text-[#999999]"
                      }`}
                    onClick={() => setSelectedTwo("both")}
                  >
                    {t("Both")}
                  </button>
                </div>
              </div>
            </div>

            {errorForm && (
              <p className="text-red-500 text-sm text-center mt-3">
                {errorForm}
              </p>
            )}

            <Modal
              open={showModal}
              onCancel={() => setShowModal(false)}
              footer={null}
              centered
              width={300}
            >
              <p style={{ textAlign: "center" }}>✅ {modalContent}</p>
            </Modal>

            <Button
              htmlType="submit"
              className={`bg-[#FE9B71] text-white rounded-full px-14 py-6 mt-5 flex mx-auto font-semibold ${loadingForm ? "opacity-50 cursor-not-allowed" : ""
                }`}
              disabled={loadingForm}
            >
              {loadingForm ? <Spin indicator={<LoadingOutlined spin />} /> : null}
              {/* <Spin indicator={<LoadingOutlined spin />} /> */}
              <p>{t("Submit")}</p>
            </Button>

            {/* <div className="text-[#028743] bg-[#F1FFF7] p-4 rounded-xl shadow-sm mt-4">

              <p className="font-semibold text-lg mb-2">{t("Your Account Details:")}</p>

              {serverLink && (
                <div className="mb-2">
                  <span className="font-medium">{t("Dashboard Link:")} </span>
                  <a href={serverLink} target="_blank" rel="noopener noreferrer" className="underline">
                    {serverLink}
                  </a>
                </div>
              )}

              {serverEmail && (
                <div className="mb-2">
                  <span className="font-medium">{t("Email:")} </span>
                  <span>{serverEmail}</span>
                </div>
              )}

              {serverPass && (
                <div>
                  <span className="font-medium">{t("Password:")} </span>
                  <span>{serverPass}</span>
                </div>
              )}

            </div> */}

            {/* {errorForm && <p>{JSON.stringify(errorForm)}</p>} */}
          </Form>
        </div>
      </div>
    </div>
  );
};

export default JoinSamoolah;
